import request from '@/utils/request'
import Setting from '@/utils/setting'
import store from '@/store'

// 获取菜单树
export function getMenuTree() {
  return request({
    url: Setting.api + '/getMenuTree',
    method: 'get'
  })
}

// 获取用户菜单
export function getUserMenus() {
  return request({
    url:  Setting.api +'/getUserMenus',
    method: 'get'
  })
}
export function getFirstLevelMenus() {
  return request({
    url:  Setting.api +'/getFirstLevelMenus',
    method: 'get'
  })
}


// 获取菜单列表
export function getMenuList(data) {
  return request({
    url:  Setting.api +'/getMenuList',
    method: 'post',
    data
  })
}
export function getModuleTypes() {
  return request({
    url:Setting.api +'/getModuleTypes',
    method: 'get'
  })
}
export function batchDeleteMenu(data) {
  return request({
    url:  Setting.api +'/batchDeleteMenu',
    method: 'post',
    data
  })
}
export function batchUpdateMenuStatus(data) {
  return request({
    url: Setting.api +'/batchUpdateMenuStatus',
    method: 'post',
    data
  })
}
// 创建菜单
export function createMenu(data) {
  return request({
    url:  Setting.api +'/createMenu',
    method: 'post',
    data
  })
}

// 编辑菜单
export function editMenu(data) {
  return request({
    url: Setting.api + '/editMenu',
    method: 'post',
    data
  })
}

// 删除菜单
export function deleteMenu(data) {
  return request({
    url:  Setting.api +'/deleteMenu',
    method: 'post',
    data
  })
}
